import React, { useMemo } from 'react';
import {
  buildStandBoardRows,
  countOpenStands,
  formatStandBoardTodayLabel,
} from '../utils/clubStandList';
import './StandBoardList.css';

/**
 * Enamel STAND BOARD list under the club map (handoff Map tab).
 */
export function StandBoardList({
  stands = [],
  currentUserId = null,
  selectedStandId = null,
  hoveredWaypointId = null,
  onHoverWaypoint,
  onSelectStand,
  onEditStand,
  onMoveStand,
  onDeleteStand,
  todayLabel = formatStandBoardTodayLabel(),
}) {
  const rows = useMemo(
    () => buildStandBoardRows(stands, { currentUserId }),
    [stands, currentUserId]
  );
  const openCount = countOpenStands(rows);

  return (
    <section className="stand-board" data-testid="stand-board" aria-label="Stand board">
      <header className="stand-board__header">
        <span className="stand-board__title" data-testid="stand-board-title">
          STAND BOARD · {todayLabel}
        </span>
        <span className="stand-board__open" data-testid="stand-board-open-count">
          {openCount} OPEN
        </span>
      </header>

      {rows.length === 0 ? (
        <p className="stand-board__empty" data-testid="stand-board-empty">
          No stands on this club map yet.
        </p>
      ) : (
        <ul className="stand-board__list">
          {rows.map((row) => {
            const selected = selectedStandId != null && Number(selectedStandId) === Number(row.id);
            const hovered =
              hoveredWaypointId != null && Number(hoveredWaypointId) === Number(row.id);
            const tagLabel = row.status === 'open' ? 'TAG OUT' : 'VIEW';
            return (
              <li key={row.id}>
                <div
                  className={[
                    'stand-board__row',
                    `stand-board__row--${row.status}`,
                    row.isMine ? 'stand-board__row--mine' : '',
                    selected ? 'stand-board__row--selected' : '',
                    hovered ? 'stand-board__row--hovered' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  data-testid={`stand-board-row-${row.id}`}
                  onMouseEnter={() => onHoverWaypoint && onHoverWaypoint(row.id)}
                  onMouseLeave={() => onHoverWaypoint && onHoverWaypoint(null)}
                  onClick={() => onSelectStand && onSelectStand(row)}
                >
                  <span
                    className="stand-board__badge"
                    aria-hidden
                    data-status={row.status}
                  >
                    {row.badge}
                  </span>
                  <span className="stand-board__body">
                    <span className="stand-board__name">{row.name}</span>
                    <span className="stand-board__meta">{row.meta}</span>
                  </span>
                  <span className="stand-board__chip" data-status={row.status} data-mine={row.isMine || undefined}>
                    {row.chip}
                  </span>
                  <div
                    className="stand-board__acts"
                    onClick={(event) => event.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="stand-board__act stand-board__act--tag"
                      data-testid={`stand-board-tag-${row.id}`}
                      onClick={() => onSelectStand && onSelectStand(row)}
                    >
                      {tagLabel}
                    </button>
                    {onMoveStand ? (
                      <button
                        type="button"
                        className="stand-board__act stand-board__act--edit"
                        data-testid={`stand-board-move-${row.id}`}
                        onClick={() => onMoveStand(row)}
                      >
                        MOVE
                      </button>
                    ) : null}
                    {onEditStand ? (
                      <button
                        type="button"
                        className="stand-board__act stand-board__act--edit"
                        data-testid={`stand-board-edit-${row.id}`}
                        onClick={() => onEditStand(row)}
                      >
                        EDIT
                      </button>
                    ) : null}
                    {onDeleteStand ? (
                      <button
                        type="button"
                        className="stand-board__act stand-board__act--danger"
                        data-testid={`stand-board-delete-${row.id}`}
                        onClick={() => onDeleteStand(row)}
                      >
                        DELETE
                      </button>
                    ) : null}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export default StandBoardList;
